import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

import LandingPage from './components/landingPage/LandingPage';
import About from './components/about/About';
import BlogPage from './components/blog/BlogPage';
import BlogPostPage from './components/blog/BlogPostPage';
import Changelog from './components/changelog/Changelog';
import TermsOfService from './components/termsOfService/TermsOfService';
import Contact from './components/contact/Contact';

// This new component will track all route changes in your app
function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    // This sends a pageview event to Google Analytics
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    
    // Only scroll to top if the new page is the homepage
    // if (location.pathname === '/') {
    //   window.scrollTo(0, 0); // Keep pages on top
    // }
    window.scrollTo(0, 0); // Keep pages on top
  }, [location]); // This effect runs every time the location changes

  return null; // This component doesn't render anything visible
}

function App() {
  return (
    <BrowserRouter>
      {/* This tracker is here so that it's active on all routes */}
      <RouteChangeTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/changelog" element={<Changelog />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;